import { WorkspaceType } from '@flowx/designer/modules/workspaces/shared/commons.types'

export enum WorkspaceObject {
  WORKSPACE = 'workspace',
}

export enum WorkspaceAction {
  SELECTED = 'selected',
  MEMBER_ADDED = 'member_added',
  MEMBER_REMOVED = 'member_removed',
}

export type WorkspaceSelectedSource = 'switcher' | 'admin_list'

type WorkspaceSelectedProperties = {
  envType: WorkspaceType
  source: WorkspaceSelectedSource
}

export type WorkspaceSelectedEvent = {
  object: WorkspaceObject.WORKSPACE
  action: WorkspaceAction.SELECTED
}

export type WorkspaceAnalyticsObject = {
  event: WorkspaceSelectedEvent
  properties: WorkspaceSelectedProperties
}
